<h3>Your Orders</h3>

<mat-spinner *ngIf="!orders" color="secondary"></mat-spinner>

<mat-table #table [dataSource]="orders" *ngIf="orders">
  <ng-container matColumnDef="ConfirmationCode">
    <mat-header-cell *matHeaderCellDef> Order </mat-header-cell>
    <mat-cell *matCellDef="let order"> <a [routerLink]="['/account/order', order.ConfirmationCode]">{{order.ConfirmationCode}}</a> </mat-cell>
  </ng-container>
  <ng-container matColumnDef="OrderDate">
    <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
    <mat-cell *matCellDef="let order"> {{order.OrderDate | date:'shortDate'}} </mat-cell>
  </ng-container>
  <ng-container matColumnDef="Cart.shipping.fullname">
    <mat-header-cell *matHeaderCellDef> Ship To </mat-header-cell>
    <mat-cell *matCellDef="let order"> {{order.Cart.shipping.fullname}} </mat-cell>
  </ng-container>
  <ng-container matColumnDef="Cart.grandTotal">
    <mat-header-cell *matHeaderCellDef> Total </mat-header-cell>
    <mat-cell *matCellDef="let order" [innerHtml]="order.Cart.grandTotal | currency2"></mat-cell>
  </ng-container>
  <ng-container matColumnDef="Status">
    <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
    <mat-cell *matCellDef="let order">
      <mat-icon *ngIf="order.Status === 'CANCELLED'" class="failure-icon" svgIcon="not-interested" matTooltip="Order Cancelled"></mat-icon>
      <mat-icon *ngIf="order.Status === 'SHIPPED' || order.Status === 'DELIVERED'" class="success-icon" svgIcon="check" matTooltip="Order Shipped"></mat-icon>
      <mat-icon *ngIf="order.Status === 'READY'" class="success-icon" svgIcon="send" matTooltip="Order Sent to Fulfillment"></mat-icon>
      <mat-icon *ngIf="order.Status === 'PROCESSING'" svgIcon="spin" matTooltip="Order In Processing"></mat-icon>
      <mat-icon *ngIf="order.Status === 'NEW'" class="success-icon" svgIcon="credit-card" matTooltip="Order Received (New)"></mat-icon>
      <mat-icon *ngIf="order.Status === 'HOLD' || order.Status === 'PRODUCTION-HOLD'" class="warning-icon" svgIcon="pause-circle" matTooltip="Order on Hold"></mat-icon>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="Reorder">
    <mat-header-cell *matHeaderCellDef ></mat-header-cell>
    <mat-cell *matCellDef="let order" class="text-nowrap fx-align--end-x">
      <button mat-stroked-button color="primary" [routerLink]="['/account/order', order.ConfirmationCode, 're-order']">
        Re-Order
      </button>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

  <mat-row *matRowDef="let order; columns: displayedColumns;" [routerLink]="['/account/order', order.ConfirmationCode]"></mat-row>
</mat-table>
